var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.77335 4.33332L6.00002 0.56665L2.22669 4.33332C1.18669 5.37332 0.666687 6.75998 0.666687 8.09332C0.666687 9.42665 1.18669 10.8333 2.22669 11.8733C3.26669 12.9133 4.63335 13.44 6.00002 13.44C7.36669 13.44 8.73335 12.9133 9.77335 11.8733C10.8134 10.8333 11.3334 9.42665 11.3334 8.09332C11.3334 6.75998 10.8134 5.37332 9.77335 4.33332Z",
    fill: "#273137"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77335 4.33332L6.00002 0.56665L2.22669 4.33332C1.18669 5.37332 0.666687 6.75998 0.666687 8.09332C0.666687 9.42665 1.18669 10.8333 2.22669 11.8733C3.26669 12.9133 4.63335 13.44 6.00002 13.44C7.36669 13.44 8.73335 12.9133 9.77335 11.8733C10.8134 10.8333 11.3334 9.42665 11.3334 8.09332C11.3334 6.75998 10.8134 5.37332 9.77335 4.33332Z",
    fill: "white",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/Water.2c80cc3bd826ae88c70a1a876b46ed13.svg";
export { ForwardRef as ReactComponent };